// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"228":"43f5309d","289":"ea077516","920":"4d04e46f"}[chunkId] + ".js";
};